module.exports = __webpack_public_path__ + "static/media/blueitem5.0f4b9028.png";